export default "__VITE_ASSET__8ffa6d21__"